import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services';
import { Router } from '@angular/router';
import { User } from '../../models/';
import { NotificationService } from '../../services';
import { UserService } from '../../services/user.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  isCollapsed: false;
  visible: boolean = false;
  visibleMenu: boolean = false;
  currentUser:any= User;
  cartNoti: number;
  isSearch=false;
  isAdmin: boolean;
  avatar:any;
  isAvatar:boolean = false;
  perPage = 10;
  page = 1;
  notificationData:any = [];
  notificationTotal:number;
  notificationDataTotal:number;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private notification: NotificationService,
    private userService:UserService,
  ) { this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    const currentUserJSON = localStorage.getItem("currentUser");
    if (currentUserJSON) {
      const currentUser = JSON.parse(currentUserJSON);
      if (currentUser && currentUser.is_admin) {
        this.isAdmin = currentUser.is_admin;
      } else {
        this.isAdmin = false; // Mặc định là false nếu không có dữ liệu hoặc không có thuộc tính is_admin
      }
    } else {
      this.isAdmin = false; // Mặc định là false nếu không có dữ liệu trong localStorage
    }
  } 

  ngOnInit() {
      this.profile();
      this.getNotification();
      this.countNotification();
  }

  logout() {
      this.authenticationService.logout();
      this.router.navigate(['/login']);
  }
  searchBtn(){
    this.isSearch = !this.isSearch;
  }

  open(): void {
    this.visibleMenu = true;
  }

  close(): void {
    this.visibleMenu = false;
  }

  profile(){
    this.userService.getProfile().subscribe((res:any)=>{
      this.avatar = environment.apiUrl + '/static/' + res.data.employee.avatar;
      if(this.avatar == "https://apihr.ttu.edu.vn/v1/static/"){
        console.log("chưa có avatar")
        this.isAvatar = false;
      }else{
        this.isAvatar = true;
      }
    });
  }

  getNotification(){
    this.notification.getNotification(this.perPage, this.page).subscribe((res:any)=>{    
      this.notificationData = res.data.data;
      this.notificationDataTotal = res.data.total;
      
    });
  }
  countNotification(): void{
    this.notification.countNotification().subscribe((res:any)=>{
      this.notificationTotal = res.data.data.length;      
    });
  }

  clickNotification(id:string, link:string): void{
    this.notification.clickNotification(id).subscribe((res:any)=>{
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        if(link == "leave"){
          this.router.navigate(['leave']);
        }
        if(link == "assignment"){
          this.router.navigate(['tasks']);
        }
      }); 
    });
  }

  readmoreNotification(){
    this.perPage = this.perPage + 5;
    this.getNotification();
  }

}
